import React, { createContext, useState, useEffect } from 'react';

export const WebSocketContext = createContext();

const WEBSOCKET_URL = 'ws://localhost:8765/ws'; // Replace with your actual WebSocket server URL

const WebSocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  // Function to create the WebSocket connection
  const createSocket = () => {
    const ws = new WebSocket(WEBSOCKET_URL);
    
    ws.onopen = () => {
      console.log('Connected to WebSocket server');
    };

    ws.onclose = (event) => {
      console.log('Disconnected from WebSocket server');
      if (event.code !== 1000) {
        // If the connection closed unexpectedly, attempt to reconnect
        reconnectWebSocket();
      }
    };

    ws.onerror = (error) => {
      console.log('WebSocket Error:', error);
    };

    setSocket(ws);
  };

  // Handle reconnection logic
  const reconnectWebSocket = () => {
    setTimeout(() => {
      console.log('Attempting to reconnect to WebSocket...');
      createSocket();
    }, 3000); // Reconnect after 3 seconds
  };

  useEffect(() => {
    // Initialize WebSocket on component mount
    createSocket();

    // Cleanup WebSocket on component unmount
    return () => {
      if (socket) {
        socket.close();
      }
    };
    // eslint-disable-next-line
  }, []); // Run this effect only once when the component mounts

  return (
    <WebSocketContext.Provider value={{ socket }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export default WebSocketProvider;
